import { render, staticRenderFns } from "./projectGrid.vue?vue&type=template&id=7bd6e172&scoped=true&"
import script from "./projectGrid.vue?vue&type=script&lang=js&"
export * from "./projectGrid.vue?vue&type=script&lang=js&"
import style0 from "./projectGrid.vue?vue&type=style&index=0&id=7bd6e172&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd6e172",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VDivider,VRow,VTooltip})
